import { NormalizeApi } from "../normalizeApi";
const BASE_ENDPOINT = 'base.rpc.customers';
export const AppealsApi = NormalizeApi({
  create: `${BASE_ENDPOINT}.electronic-appeal`
});